// Format phone number with country code
export function formatPhoneWithCountryCode(phone, countryCode = '+1') {
  if (!phone) return '';
  return `${countryCode} ${phone}`;
}

// Format phone number for display
export function formatPhoneNumber(phoneNumber) {
  const cleaned = ('' + phoneNumber).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return phoneNumber;
}

// Format phone number as user types (real-time)
export function formatPhoneInput(value) {
  // Remove all non-digit characters
  const cleaned = value.replace(/\D/g, '');
  
  // Limit to 10 digits
  const limited = cleaned.substring(0, 10);
  
  // Format as (XXX) XXX-XXXX
  if (limited.length === 0) return '';
  if (limited.length <= 3) return `(${limited}`;
  if (limited.length <= 6) return `(${limited.slice(0, 3)}) ${limited.slice(3)}`;
  return `(${limited.slice(0, 3)}) ${limited.slice(3, 6)}-${limited.slice(6)}`;
}

// Format phone for tel: link
export function formatPhoneForLink(phone) {
  return phone.replace(/[^\d+]/g, '');
}

// Generate vCard
export function generateVCard(data) {
  const vCardLines = [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `FN:${data.fullName}${data.credentials ? ` ${data.credentials}` : ''}`,
    `N:${data.fullName.split(' ').pop() || ''};;${data.fullName.split(' ').slice(0, -1).join(' ') || ''};${data.credentials || ''};`,
    `ORG:${data.company}`,
    `TITLE:${data.jobTitle}`,
  ];

  if (data.email) vCardLines.push(`EMAIL:${data.email}`);
  if (data.phoneNumber) vCardLines.push(`TEL;type=WORK:${data.phoneNumber.replace(/[^\d+]/g, '')}`);
  if (data.mobileNumber) vCardLines.push(`TEL;type=CELL:${data.mobileNumber.replace(/[^\d+]/g, '')}`);
  if (data.faxNumber) vCardLines.push(`TEL;type=FAX:${data.faxNumber.replace(/[^\d+]/g, '')}`);
  if (data.website) vCardLines.push(`URL:https://${data.website.replace(/^https?:\/\//, '')}`);
  if (data.address) vCardLines.push(`ADR:;;${data.address};;;;`);
  if (data.linkedin) vCardLines.push(`URL;type=linkedin:https://linkedin.com/in/${data.linkedin}`);
  if (data.xUsername) vCardLines.push(`URL;type=x:https://x.com/${data.xUsername}`);
  if (data.facebook) vCardLines.push(`URL;type=facebook:https://facebook.com/${data.facebook}`);
  if (data.instagram) vCardLines.push(`URL;type=instagram:https://instagram.com/${data.instagram}`);
  if (data.youtube) vCardLines.push(`URL;type=youtube:https://youtube.com/${data.youtube}`);
  if (data.disclaimer) vCardLines.push(`NOTE:${data.disclaimer}`);

  vCardLines.push('END:VCARD');
  return vCardLines.join('\n');
}

// Download vCard
export function downloadVCard(vCardData, filename = 'contact.vcf') {
  const blob = new Blob([vCardData], { type: 'text/vcard' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
